import { API } from "aws-amplify";
import * as queries from "../graphql/queries";
import * as mutations from "../graphql/mutations";
import Identity from "./identity";

const reviews = new function() {
	
	// fixes bugs in amplify mock API handling
	let fixed_getReview = queries.getReview.replace(/\s_\w+/g, '');
	let fixed_listReviews = queries.listReviews.replace(/\s_\w+/g, '');
	let fixed_createReview = mutations.createReview.replace(/\s_\w+/g, '');
	let fixed_updateReview = mutations.updateReview.replace(/\s_\w+/g, '');
	let fixed_deleteReview = mutations.deleteReview.replace(/\s_\w+/g, '');

	this.get = async function(id) {
		let r = await API.graphql({
			query: fixed_getReview,
			authMode: 'AWS_IAM',
			variables: {
				id: id
			}
		});
		return r.data.getReview;
	};

	this.getMine = async function(diseaseNormalizedName) {
		if (!Identity.username) {
			return null;
		}

		let possibles = await this.listByDisease(diseaseNormalizedName, Identity.username);
		if (possibles.length == 1) {
			return possibles[0];
		} else {
			return null;
		}
	};

	this.find = async function(query) {
		let r = await API.graphql({
			query: fixed_listReviews,
			authMode: 'AWS_IAM',
			variables: {
				filter: query
			}
		});
		return r.data.listReviews.items;
	};

	this.listByDisease = async function(diseaseNormalizedName, owner) {
		let query = {
			diseaseNormalizedName: {
				eq: diseaseNormalizedName.toLowerCase()
			},
		}

		// in prod, owner condition needs to be absent if null, despite the fact
		// it works OK locally to provide an `owner eq {}` condition ...
		if (owner) {
			query.owner = {
				eq: owner
			}
		}
		return await this.find(query);
	};

	this.add = async function(review) {
		let existing = await this.getMine(review.diseaseNormalizedName);
		if (existing) {
			throw Error("Review already exists!");
		} else {
			review.id = null;
			let r = await API.graphql({
				authMode: "AMAZON_COGNITO_USER_POOLS",
				query: fixed_createReview,
				variables: {
					input: review
				}
			});
			console.log('created Review', r);
			return r.data.createReview;
		}
	};

	this.update = async function(review) {
		let r = await API.graphql({
			query: fixed_updateReview,
			authMode: "AMAZON_COGNITO_USER_POOLS",
			variables: {
				input: review
			}
		});
		console.log('updated Review', r);
		return r.data.updateReview;
	};

	this.put = async function(review) {
		if (review.id) {
			return await this.update(review);
		} else {
			let added = await this.add(review);
			review.id = added.id;
			return added;
		}
	};

	this.remove = async function(review) {
		let r = await API.graphql({
			authMode: "AMAZON_COGNITO_USER_POOLS",
			query: fixed_deleteReview,
			variables: {
				input: review
			}
		});
		console.log('deleted Review', r);
		return r;
	};

};

Object.freeze(reviews);
export default reviews;
